<template>
  <div class="c-emptyPanel">
    <p class="c-emptyPanel_title">
      <slot name="title"></slot>
    </p>
    <p class="c-emptyPanel_body">
      <slot name="body"></slot>
    </p>
    <p class="c-emptyPanel_link">
      <slot name="link"></slot>
    </p>
  </div>
</template>
<script>
export default {
  name: 'EmptyPanel',
  props: {
    href: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
.c-emptyPanel {
  padding: 1em;

  a {
    @include link-effect;
  }

  &_title {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 20px;
  }

  &_body {
    margin-bottom: 12px;
    font-size: 14px;
  }

  &_link {
    margin-top: 20px;
    margin-bottom: 0;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
    a {
      background-color: $color-gray-100;
      border-radius: 20px;
      padding: 0.5em 20px;
      font-size: 12px;
    }
  }
}

@media (min-width: $breakpoint-m) {
  .c-emptyPanel {
    padding: 4%;
    border: 1px solid $color-gray-200;
    border-radius: 5px;
    background-color: $color-bg-pale;
    text-align: center;

    &_title {
      margin-bottom: 12px;
      font-size: 24px;
    }

    &_body {
      margin-bottom: 8px;
      min-height: 75px;
      font-size: 16px;
    }

    &_link {
      a {
        background: none;
        font-size: 14px;
      }
    }
  }
}
</style>
